import { createMuiTheme, colors } from '@material-ui/core';
import shadows from './shadows';
import typography from './typography';

const theme = createMuiTheme({
  palette: {
    background: {
      dark: '#F4F6F8',
      default: colors.common.white,
      paper: colors.common.white
    },
    primary: {
      //main: "#3F90EC"//colors.indigo[500]
      // main: "#0d4381"//colors.indigo[500]
      //main: "#242a2e",  //Dark theme. I like this one
      //main: "#041422", //This is very good
      // main: "#082846",// Also a good option
      main: "#0c3c69",
    },
    secondary: {
      main: colors.indigo[500]
    },
    text: {
      primary: colors.blueGrey[900],
      secondary: colors.blueGrey[600]
    }
  },
  shadows,
  typography
});

export default theme;
